import React, { useEffect, useState } from "react";
import './styles.css'
import CommonScreenContent from "../../../components/screen/common-screen-content/commonScreenContent";
import ScreenLabel from "../../../components/label/screen-label/screenLabel";
import Loader from '../../../components/loader/loader.component'
import { ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom';
import Select from 'react-select'
import { displayErrorToast, displaySuccessToast, isEmpty, isLoggedInUserBusiness, isLoggedInUserEmployee, isNull, removeSpecialCharAndChangeToPascal } from "../../../utils/Utils";
import {
    peformanceGoalDetailsRequest, peformanceAddGoalCommentRequest, peformanceAddGoalCommentRequestStatus,
    peformanceUpdateGoalRequest, peformanceUpdateGoalRequestStatus
} from '../../../redux/performance/peformance.action'
import moment from "moment";
import { API_CONSTANTS, APP_CONSTANTS } from "../../../utils/AppConstants";
import CommonFormBorder from "../../../components/common-form-border/commonFormBorder";
import FormFieldLabel from "../../../components/label/form-field-label/formFieldLabel";
import Modal from 'react-bootstrap/Modal';
import ButtonRow from "../../../components/button/button-row/buttonRow";
import CommonButton from "../../../components/button/common-button/commonButton";
import CommonInputFloatFull from "../../../components/input/common-input-float-full/commonInputFloatFull";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CommonCheckbox from "../../../components/common-checkbox/commonCheckbox";

const PerformanceGoalDetail = props => {
    const { user, employeeSelectedBusiness, employeeSelectedLocation } = useSelector(state => state.user)
    const [isLoading, setLoading] = useState(false)
    const dispatch = useDispatch()
    let navigate = useNavigate();
    const { state } = useLocation()
    const { peformanceGoalDetailSuccess, peformanceGoalDetailError,
        peformanceGoalAddCommentSuccess, peformanceGoalAddCommentError, peformanceGoalAddCommentReqStatus,
        peformanceUpdateGoalSuccess, peformanceUpdateGoalError, peformanceUpdateGoalReqStatus } = useSelector(state => state.peformance)
    const [comment, setComment] = useState('')
    const [selectedStatus, setSelectedStatus] = useState()
    const STATUS_LIST = [
        { key: APP_CONSTANTS.PERFORMANCE_GOAL_STATUS.NEW, value: removeSpecialCharAndChangeToPascal(APP_CONSTANTS.PERFORMANCE_GOAL_STATUS.NEW) },
        { key: APP_CONSTANTS.PERFORMANCE_GOAL_STATUS.IN_PROGRESS, value: removeSpecialCharAndChangeToPascal(APP_CONSTANTS.PERFORMANCE_GOAL_STATUS.IN_PROGRESS) },
        { key: APP_CONSTANTS.PERFORMANCE_GOAL_STATUS.COMPLETED, value: removeSpecialCharAndChangeToPascal(APP_CONSTANTS.PERFORMANCE_GOAL_STATUS.COMPLETED) },
        { key: APP_CONSTANTS.PERFORMANCE_GOAL_STATUS.ON_HOLD, value: removeSpecialCharAndChangeToPascal(APP_CONSTANTS.PERFORMANCE_GOAL_STATUS.ON_HOLD) },
    ]
    const [isEditEndDate, setIsEditEndDate] = useState(false)
    const [endDate, setEndDate] = useState(new Date())
    const [showStatusChangeModal, setShowStatusChangeModal] = useState(false)

    useEffect(() => {
        fetchGoalDetails()
    }, [])

    const fetchGoalDetails = () => {
        setLoading(true)
        dispatch(peformanceGoalDetailsRequest(state))
    }

    useEffect(() => {
        if (!isEmpty(peformanceGoalDetailSuccess)) {
            setLoading(false)
        } else if (!isEmpty(peformanceGoalDetailError)) {
            setLoading(false)
        }
    }, [peformanceGoalDetailSuccess, peformanceGoalDetailError])

    useEffect(() => {
        if (peformanceGoalAddCommentReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(false)
            displaySuccessToast(peformanceGoalAddCommentSuccess.data?.message)
            fetchGoalDetails()
            setComment('')
        } else if (peformanceGoalAddCommentReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            displayErrorToast(peformanceGoalAddCommentError.message)
        }
        if (peformanceGoalAddCommentReqStatus?.length) {
            dispatch(peformanceAddGoalCommentRequestStatus(''))
        }
    }, [peformanceGoalAddCommentSuccess, peformanceGoalAddCommentError, peformanceGoalAddCommentReqStatus])

    useEffect(() => {
        if (peformanceUpdateGoalReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(false)
            displaySuccessToast(peformanceUpdateGoalSuccess.data?.message)
            fetchGoalDetails()
            setIsEditEndDate(false)
        } else if (peformanceUpdateGoalReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            displayErrorToast(peformanceUpdateGoalError.message)
        }
        if (peformanceUpdateGoalReqStatus?.length) {
            dispatch(peformanceUpdateGoalRequestStatus(''))
        }
    }, [peformanceUpdateGoalSuccess, peformanceUpdateGoalError, peformanceUpdateGoalReqStatus])

    const handleAddCommentSubmitClick = () => {
        if (isEmpty(state)) {
            displayErrorToast('Goal details not available. Please try refreshing the data.')
        } else if (isEmpty(peformanceGoalDetailSuccess)) {
            displayErrorToast('Goal details not available. Please try refreshing the data.')
        } else if (isEmpty(comment)) {
            displayErrorToast('Comment cannot be blank')
        } else {
            setLoading(true)
            const data = {
                performanceGoalId: state,
                comment: comment,
                sender: `${user.data.userDetails.firstName} ${user.data.userDetails.lastName}`
            }
            dispatch(peformanceAddGoalCommentRequest(data))
        }
    }

    const handleUpdateStatusSubmitClick = () => {
        if (isEmpty(state)) {
            displayErrorToast('Goal details not available. Please try refreshing the data.')
        } else if (isEmpty(peformanceGoalDetailSuccess)) {
            displayErrorToast('Goal details not available. Please try refreshing the data.')
        } else if (isEmpty(selectedStatus)) {
            displayErrorToast('Status not selected')
        } else if (isEditEndDate === true && isEmpty(endDate)) {
            displayErrorToast('End date not selected')
        } else {
            setLoading(true)
            const data = {
                performanceGoalId: state,
                status: selectedStatus.key
            }
            if (isEditEndDate === true && !isEmpty(endDate)) {
                data.endDate = moment(endDate).utc().format("YYYY-MM-DD hh:mm:ss A")
            }
            dispatch(peformanceUpdateGoalRequest(data))
            setShowStatusChangeModal(false)
        }
    }

    const isEditStatusAllowed = (item) => {
        let userId = isLoggedInUserBusiness(user) ? user.data.userDetails.userId : user.data.userDetails.employeeId

        if (parseFloat(item.employeeId) === parseFloat(userId) &&
            item.employeeUserType === user.data.userDetails.userType) {
            return true
        } else {
            return false
        }
    }

    const getStatusClassname = (status) => {
        if (status === APP_CONSTANTS.PERFORMANCE_GOAL_STATUS.NEW) {
            return 'pd-status-container pd-status-container-new'
        } else if (status === APP_CONSTANTS.PERFORMANCE_GOAL_STATUS.IN_PROGRESS) {
            return 'pd-status-container pd-status-container-in-progress'
        } else if (status === APP_CONSTANTS.PERFORMANCE_GOAL_STATUS.COMPLETED) {
            return 'pd-status-container pd-status-container-complete'
        } else if (status === APP_CONSTANTS.PERFORMANCE_GOAL_STATUS.ON_HOLD) {
            return 'pd-status-container pd-status-container-hold'
        }
    }


    return (
        <>
            <CommonScreenContent>
                <ScreenLabel label='Goal Details' />
                {!isEmpty(peformanceGoalDetailSuccess) && !isEmpty(peformanceGoalDetailSuccess.data) && <CommonFormBorder>
                    <div className="pd-status-row-container">
                        <div className={getStatusClassname(peformanceGoalDetailSuccess.data.status)}>{removeSpecialCharAndChangeToPascal(peformanceGoalDetailSuccess.data.status)}</div>
                        {isEditStatusAllowed(peformanceGoalDetailSuccess.data) && peformanceGoalDetailSuccess.data.status !== APP_CONSTANTS.PERFORMANCE_GOAL_STATUS.COMPLETED && <div className="ed-role-img-container"
                            onClick={() => { setShowStatusChangeModal(true) }}>
                            <img src={require('../../../assets/ic_edit_pen.png')} className="img" />
                        </div>}
                    </div>
                    <div className="pd-name-container">
                        <div className="pd-name-label">{peformanceGoalDetailSuccess.data.title}</div>
                    </div>
                    <div className="pd-description-container">
                        <div className="pd-description-label">{peformanceGoalDetailSuccess.data.description}</div>
                    </div>
                    {!isEmpty(peformanceGoalDetailSuccess.data.endDate) && <div className="pd-icon-row-container">
                        <div className="pd-icon-container">
                            <img src={require('../../../assets/ic_calendar.png')} className="img" />
                        </div>
                        <div className="pd-icon-label">End Date - {moment.utc(peformanceGoalDetailSuccess.data.endDate).local().format('DD MMM YYYY')}</div>
                    </div>}
                    {!isEmpty(peformanceGoalDetailSuccess.data.reviewYear) && <div className="pd-icon-row-container">
                        <div className="pd-icon-container">
                            <img src={require('../../../assets/ic_calendar.png')} className="img" />
                        </div>
                        <div className="pd-icon-label">Review Year - {peformanceGoalDetailSuccess.data.reviewYear}</div>
                    </div>}
                    <FormFieldLabel label='Comments' />
                    {isEmpty(peformanceGoalDetailSuccess.data.comments) && <div className="content-error">No Comments Found!</div>}
                    {!isEmpty(peformanceGoalDetailSuccess.data.comments) && <div className="td-comment-col-container">
                        {peformanceGoalDetailSuccess.data.comments.map(item => (<div className="td-comment-item-container">
                            <div className="td-comment-date">{moment.utc(item.date).local().format('DD/MM/YYYY')}</div>
                            <div className="td-comment">{item.comment}</div>
                            <div className="td-comment-name">{item.sender}</div>
                        </div>))}
                    </div>}
                    <CommonInputFloatFull
                        type='text'
                        id='comments'
                        onChange={e => setComment(e.target.value)}
                        placeholder='Enter new comment'
                        value={comment}
                        rows={2}
                        multiline={true} />
                    <div className="td-comment-btn-container">
                        <CommonButton
                            label='Add Comment'
                            isInverted={true}
                            onClick={() => { handleAddCommentSubmitClick() }} />
                    </div>
                </CommonFormBorder>}
                {!isEmpty(peformanceGoalDetailError) && <div className="content-error">{peformanceGoalDetailError.message}</div>}
            </CommonScreenContent>
            <Modal
                onHide={() => { setShowStatusChangeModal(false) }}
                show={showStatusChangeModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    Update Details
                </Modal.Header>
                <Modal.Body>
                    <FormFieldLabel label='Select Status' />
                    <Select
                        className='select-full-width-no-border'
                        value={selectedStatus}
                        getOptionLabel={e => e.value}
                        getOptionValue={e => e}
                        options={STATUS_LIST}
                        placeholder='Select Status'
                        onChange={e => setSelectedStatus(e)} />
                    <CommonCheckbox
                        id='editEndDate'
                        label='Update End date?'
                        value={isEditEndDate}
                        onChange={() => {
                            setIsEditEndDate(!isEditEndDate)
                        }}
                    />
                    {isEditEndDate && <div className="as-date-parent-container-full">
                        <FormFieldLabel label='End Date' />
                        <DatePicker
                            className="as-date-container"
                            selected={endDate}
                            minDate={new Date()}
                            onChange={(date) => {
                                setEndDate(date)
                            }}
                            dateFormat="MMMM d, yyyy"
                        />
                    </div>}
                    <ButtonRow>
                        <CommonButton label='Update'
                            onClick={() => {
                                handleUpdateStatusSubmitClick()
                            }}
                        />
                    </ButtonRow>
                </Modal.Body>
            </Modal>
            <ToastContainer />
            <Loader active={isLoading} text='Please wait...' />
        </>
    )
}

export default PerformanceGoalDetail